import { Component } from '@angular/core';

@Component({
  selector: 'app-pat-payment-panel-paygreen-lunchr',
  templateUrl: './pat-payment-panel-paygreen-lunchr.component.html',
})
export class PatPaymentPanelPaygreenLunchrComponent {}
